<template>
  <CCard>
    <CCardHeader class="d-flex">
      <h2
        v-if="!id"
        class="mb-0"
      >
        New User
      </h2>
      <h2
        v-else
        class="mb-0"
      >
        Edit User
      </h2>
    </CCardHeader>
    <CCardBody>
      <form
        v-if="!id || !user_loading"
        autocomplete="off"
        @submit.prevent="submit"
      >
        <CRow>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_user.name"
              label="Name"
              autocomplete="name"
              :add-input-classes="{ 'is-invalid': hasError('name') }"
              :invalid-feedback="getError('name')"
            />
          </CCol>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_user.email"
              label="Email"
              autocomplete="email"
              :add-input-classes="{ 'is-invalid': hasError('email') }"
              :invalid-feedback="getError('email')"
            />
          </CCol>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_user.country"
              label="Country"
              :add-input-classes="{ 'is-invalid': hasError('country') }"
              :invalid-feedback="getError('country')"
            />
          </CCol>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_user.city"
              label="City"
              :add-input-classes="{ 'is-invalid': hasError('city') }"
              :invalid-feedback="getError('city')"
            />
          </CCol>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_user.zip"
              label="Zip Code"
              :add-input-classes="{ 'is-invalid': hasError('zip') }"
              :invalid-feedback="getError('zip')"
            />
          </CCol>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_user.phone"
              label="Phone"
              placeholder="+34600000000"
              :add-input-classes="{ 'is-invalid': hasError('phone') }"
              :invalid-feedback="getError('phone')"
            />
          </CCol>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_user.address_line_1"
              label="Address Line 1"
              :add-input-classes="{ 'is-invalid': hasError('address_line_1') }"
              :invalid-feedback="getError('address_line_1')"
            />
          </CCol>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_user.address_line_2"
              label="Address Line 2"
              :add-input-classes="{ 'is-invalid': hasError('address_line_2') }"
              :invalid-feedback="getError('address_line_2')"
            />
          </CCol>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model="new_user.address_line_3"
              label="Address Line 3"
              :add-input-classes="{ 'is-invalid': hasError('address_line_3') }"
              :invalid-feedback="getError('address_line_3')"
            />
          </CCol>
          <CCol
            md="6"
            lg="4"
          >
            <CInput
              v-model.number="new_user.library_limit"
              type="number"
              label="Library Limit"
              :add-input-classes="{ 'is-invalid': hasError('library_limit') }"
              :invalid-feedback="getError('library_limit')"
            />
          </CCol>
        </CRow>
        <CButton
          type="submit"
          color="primary"
        >
          Save
        </CButton>
      </form>
      <div
        v-else
        class="mb-3"
      >
        <CSpinner
          style="width: 2rem; height: 2rem"
          color="primary"
          grow
        />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import hasApiValidation from '@/mixins/hasApiValidation';

export default {
  name: 'EditEnterpriseUser',
  mixins: [hasApiValidation],
  props: ['id'],
  data() {
    return {
      roles: [],
      new_user: {
        name: '',
        email: '',
        address_line_1: '',
        address_line_2: '',
        address_line_3: '',
        phone: '',
        zip: '',
        city: '',
        country: '',
        library_limit: 0,
      },
      loading_roles: true,
      user_loading: false,
    };
  },
  mounted() {
    this.user_loading = true;
    if (this.id) {
      this.fetchUser(this.id);
    }
  },
  methods: {
    fetchUser(id) {
      this.$http
        .get('/enterprise-users/' + id)
        .then(({ data }) => {
          this.new_user.id = data.data.id;
          this.new_user.name = data.data.name;
          this.new_user.email = data.data.email;
          this.new_user.address_line_1 = data.data.address_line_1;
          this.new_user.address_line_2 = data.data.address_line_2;
          this.new_user.address_line_3 = data.data.address_line_3;
          this.new_user.country = data.data.country;
          this.new_user.phone = data.data.phone;
          this.new_user.zip = data.data.zip;
          this.new_user.city = data.data.city;
          this.new_user.library_limit = data.data.library_limit;
        })
        .catch(({ response }) => {
          this.$router.push({ name: 'Enterprise Users' }).then(() => {
            this.$toast.error(response.data.message);
          });
        })
        .finally(() => {
          this.user_loading = false;
        });
    },
    submit() {
      let payload = { ...this.new_user };

      if (payload.phone) {
        payload.phone = payload.phone.replace(/[^0-9+]/g, '');
      }
      if (this.id) {
        this.update();
      } else {
        this.save();
      }
    },
    save() {
      this.setErrors({});
      this.$http
        .post('/enterprise-users/', this.new_user)
        .then((data) => {
          this.$toast.success('Created');
          this.setErrors({});
          this.$router.push({ name: 'Enterprise Users' });
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
          this.setErrors(response.data.errors);
        });
    },
    update() {
      this.$http
        .put('/enterprise-users/' + this.id, this.new_user)
        .then((data) => {
          this.$toast.success('Updated');
          this.$router.push({ name: 'Enterprise Users' });
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
          this.setErrors(response.data.errors);
        });
    },
  },
};
</script>

<style scoped></style>
